var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.423 3.492c-.453.42-.757 1.103-.757 2.175v4.667c0 1.07.304 1.754.757 2.175.46.427 1.153.658 2.076.658h6.667c.923 0 1.616-.231 2.076-.658.454-.421.757-1.104.757-2.175V5.667c0-1.072-.303-1.755-.757-2.175-.46-.428-1.153-.659-2.076-.659H5.499c-.923 0-1.616.231-2.076.659Zm-.68-.733c.706-.656 1.68-.925 2.756-.925h6.667c1.077 0 2.05.269 2.757.925.713.662 1.076 1.646 1.076 2.908v4.667c0 1.261-.363 2.245-1.076 2.908-.707.656-1.68.925-2.757.925H5.499c-1.076 0-2.05-.27-2.757-.925-.713-.663-1.076-1.647-1.076-2.909V5.668c0-1.262.363-2.246 1.076-2.908Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.556 5.688a.5.5 0 0 1-.078.703L10.39 8.058c-.868.692-2.253.692-3.122 0h-.002L5.186 6.39a.5.5 0 0 1 .626-.78L7.89 7.275c.504.402 1.372.401 1.876 0l2.087-1.666a.5.5 0 0 1 .702.078Z",
    fill: "currentColor"
  })));
};
export default SvgEnvelope;